import JSRouter from "adminPage/JSRouter";
import Message from "base/Message";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";

JSRouter.register('login', new RegExp('^/reset/?$'), (url_data, page_data) => {
    FormValidator.attach($(".js-reset-password-form"), {
        inputs: {
            new_password: {messages: {empty: "You must enter your new password"}},
            repeat_new_password: {messages: {empty: "You must repeat your new password"}}
        }
    }).on('init', function () {
        let $form = this.$form;
        if ($form.find(".js-new-password-repeat").length > 0) {
            $form.find(".js-new-password-repeat").data("Validator").on("validate", function (event) {
                if ($form.find(".js-new-password").val() !== $form.find(".js-new-password-repeat").val()) {
                    event.valid = false;
                    event.message = 'Passwords don\'t match';
                }
            });
            $form.find(".js-new-password").data("Validator").on("validate", function () {
                $form.find(".js-new-password-repeat").data("Validator").validate();
            });
        }
    }).on("submit", function ($form) {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("adminUsers", "login/forgotten/submit", {
            password: $form.find(".js-new-password").val(),
            token: page_data.token,
            key: page_data.key
        }, Ajax.ADMIN).then(function () {
            window.location = window.CONFIG.urls.website;
        }, function (e) {
            new Message(e.message, "Couldn't log you in");
            $btn.removeClass("admin-btn--loading");
        })
    });

    $("body").on("change", ".js-show-password", function () {
        $(".js-new-password,.js-new-password-repeat").attr("type", $(this).is(":checked") ? 'text' : 'password');
    });
});
